/**
 * Opções de font-family (stack CSS) para o editor de panfleto.
 * Valores devem coincidir com o que é salvo em layoutStyle.*.fontFamily
 */
export interface PanfletoFontOption {
  value: string;
  label: string;
}

/** Fonte dos preços (valores "De" / "Por" e estilo price do layout). */
export const PANFLETO_PRICE_FONT_OPTIONS: PanfletoFontOption[] = [
  {
    value: "'Oferta do Dia', Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif",
    label: 'Oferta do Dia (cartaz de mercado)',
  },
  { value: "'Bebas Neue', Impact, sans-serif", label: 'Bebas Neue (cartaz, alta visibilidade)' },
  { value: "'Anton', Impact, sans-serif", label: 'Anton (título forte)' },
  { value: "'Oswald', 'Arial Narrow', sans-serif", label: 'Oswald (condensada, vitrine)' },
  { value: "Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif", label: 'Impact (sistema, estilo cartaz)' },
  { value: "Arial, Helvetica, sans-serif", label: 'Arial' },
  { value: "Georgia, 'Times New Roman', serif", label: 'Georgia' },
  { value: "Verdana, Geneva, sans-serif", label: 'Verdana' },
  { value: "'Segoe UI', Tahoma, sans-serif", label: 'Segoe UI' },
];

/** Fonte dos textos: cabeçalho, linhas de produto, código de barras, quantidade/unidade (productName, category, description, unit). */
export const PANFLETO_TEXT_FONT_OPTIONS: PanfletoFontOption[] = [
  {
    value: "'Oferta do Dia', Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif",
    label: 'Oferta do Dia (cartaz de mercado)',
  },
  { value: "'Oswald', 'Arial Narrow', sans-serif", label: 'Oswald (rótulos e destaques)' },
  { value: "'Bebas Neue', Impact, sans-serif", label: 'Bebas Neue' },
  { value: "Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif", label: 'Impact' },
  { value: "Arial, Helvetica, sans-serif", label: 'Arial' },
  { value: "'Times New Roman', Times, serif", label: 'Times New Roman' },
  { value: "'Courier New', Courier, monospace", label: 'Courier New' },
  { value: "Georgia, 'Times New Roman', serif", label: 'Georgia' },
  { value: "Verdana, Geneva, sans-serif", label: 'Verdana' },
  { value: "'Segoe UI', Tahoma, sans-serif", label: 'Segoe UI' },
];
